// MUI Dialog + 뒤로가기로 닫기. 앱의 다이얼로그는 이 컴포넌트를 쓴다(사용법은 MUI Dialog와 같다).
// 뒤로가기는 ESC와 같게 취급한다: onClose가 없거나 disableEscapeKeyDown이면 뒤로가기로도 닫지 않는다.
// onClose는 (event, 'backButton')으로 불린다.
// backClose={false}: 뒤로가기를 가로채지 않는다(닫기가 곧 다른 화면 이동인 다이얼로그 등 — 가로채면
// 뒤로가기가 앞으로 가는 이동이 되어 그 화면에 갇힌다).
import React, { useEffect, useRef } from 'react';
import { Dialog } from '@mui/material';
import { registerBackClose } from '../utils/backClose';

export function useBackClose(active, onClose) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    if (!active) return undefined;
    return registerBackClose(() => onCloseRef.current?.({}, 'backButton'));
  }, [active]);
}

const AppDialog = React.forwardRef(function AppDialog({ backClose = true, ...props }, ref) {
  const { open, onClose, disableEscapeKeyDown } = props;
  useBackClose(backClose && !!open && !!onClose && !disableEscapeKeyDown, onClose);
  return <Dialog ref={ref} {...props} />;
});

export default AppDialog;
